import { HttpContextToken, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { LoadingService } from '@shared/services/loading.service'
import { Injectable, inject } from '@angular/core'
import { finalize } from 'rxjs'

export const SkipLoading = new HttpContextToken<boolean>(() => false)
export const CancellingLoan = new HttpContextToken<boolean>(() => false)
export const GetCardLoan = new HttpContextToken<boolean>(() => false)
export const LoadingDashboardData = new HttpContextToken<boolean>(() => false)
export const LoadingEvents = new HttpContextToken<boolean>(() => false)
export const LoadingInvoices = new HttpContextToken<boolean>(() => false)
export const LoadingPreAuthTransactions = new HttpContextToken<boolean>(() => false)
export const LoadingServiceNotifications = new HttpContextToken<boolean>(() => false)
export const LoadingTransactions = new HttpContextToken<boolean>(() => false)
export const MovingInvoiceDueDate = new HttpContextToken<boolean>(() => false)
export const RenewCard = new HttpContextToken<boolean>(() => false)
export const ShowInterestHistory = new HttpContextToken<boolean>(() => false)
export const UpdateProfile = new HttpContextToken<boolean>(() => false)

export enum LoadingContexts {
  cancellingLoan = 'cancellingLoan',
  getCardLoan = 'getCardLoan',
  loadingDashboardData = 'loadingDashboardData',
  loadingEvents = 'loadingEvents',
  loadingInvoices = 'loadingInvoices',
  loadingPreAuthTransactions = 'loadingPreAuthTransactions',
  loadingServiceNotifications = 'loadingServiceNotifications',
  loadingTransactions = 'loadingTransactions',
  movingInvoiceDueDate = 'movingInvoiceDueDate',
  renewCard = 'renewCard',
  showInterestHistory = 'showInterestHistory',
  updateProfile = 'updateProfile',
}

@Injectable({
  providedIn: 'root',
})
export class LoadingInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService)
  private contexts = new Map<HttpContextToken<boolean>, LoadingContexts>([
    [CancellingLoan, LoadingContexts.cancellingLoan],
    [GetCardLoan, LoadingContexts.getCardLoan],
    [LoadingDashboardData, LoadingContexts.loadingDashboardData],
    [LoadingEvents, LoadingContexts.loadingEvents],
    [LoadingInvoices, LoadingContexts.loadingInvoices],
    [LoadingPreAuthTransactions, LoadingContexts.loadingPreAuthTransactions],
    [LoadingServiceNotifications, LoadingContexts.loadingServiceNotifications],
    [LoadingTransactions, LoadingContexts.loadingTransactions],
    [MovingInvoiceDueDate, LoadingContexts.movingInvoiceDueDate],
    [RenewCard, LoadingContexts.renewCard],
    [ShowInterestHistory, LoadingContexts.showInterestHistory],
    [UpdateProfile, LoadingContexts.updateProfile],
  ])

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    if (req.context.get(SkipLoading)) {
      return next.handle(req)
    }
    this.loadingService.on()
    for (const item of this.contexts.entries()) {
      if (req.context.has(item[0])) {
        this.loadingService.setActiveContext(item[1])
      }
    }
    return next.handle(req).pipe(
      finalize(() => {
        this.loadingService.off()
        for (const item of this.contexts.entries()) {
          if (req.context.has(item[0])) {
            this.loadingService.unsetActiveContext(item[1])
          }
        }
      }),
    )
  }
}
